/* ==================================================
   AI PET STUDIO — Wizard logic (frontend only, mock AI)
   ================================================== */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var state = {
    petPhotoDataUrl: null,
    petPhotoFile: null,
    petPhotoS3Url: null,
    selectedStyle: null,
    previews: [],
    selectedPreviewIdx: null,
    finalDesignUrl: null,
    product: 'cover',
    coverModel: 'iphone-17-pro',
    posterFormat: 'A4',
    bundleModel: 'iphone-17-pro'
  };

  /* API base detection: dev -> localhost MAMP v1.1, prod -> api.ntngrp v1.1 (Elastic Beanstalk) */
  function apiBase() {
    if (window.AIP_API_BASE) return String(window.AIP_API_BASE).replace(/\/+$/, '');
    var host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:8888/v1.1';
    return 'https://api.ntngrp.com/v1.1';
  }

  /* AI generation model — gemini-2.5-flash-image: best velocita'/costi. */
  var AI_MODEL = 'gemini-2.5-flash-image';
  var AI_IMAGE_SIZE = '1K';

  /* Shopify product variants (Coverlab live).
     Cover product: 10651127644493 — Portrait AI Pet Tough iPhone Case (€27.95).
     Poster product: 10651128103245 — Portrait AI Pet Poster (A4 €19.95, A3 €22.95). */
  var COVER_VARIANTS = window.AIP_COVER_VARIANTS || {
    'iphone-17-pro':     53852399665485,
    'iphone-17-pro-max': 53852399698253,
    'iphone-17':         53852399731021,
    'iphone-17-air':     53852399763789,
    'iphone-16-pro':     53852399796557,
    'iphone-16-pro-max': 53852399829325,
    'iphone-16':         53852399862093,
    'iphone-16-plus':    53852399894861,
    'iphone-15-pro':     53852399927629,
    'iphone-15-pro-max': 53852399960397,
    'iphone-15':         53852399993165,
    'iphone-15-plus':    53852400025933,
    'iphone-14-pro':     53852400058701,
    'iphone-14-pro-max': 53852400091469,
    'iphone-14':         53852400124237,
    'iphone-14-plus':    53852400157005,
    'iphone-13-pro':     53852400189773,
    'iphone-13-pro-max': 53852400222541,
    'iphone-13':         53852400255309
  };
  var POSTER_VARIANTS = window.AIP_POSTER_VARIANTS || {
    'A4': 53852401467725,
    'A3': 53852401500493
  };
  var POSTER_PRICES = { 'A4': '€ 19,95', 'A3': '€ 22,95' };

  /* Digital download — Portrait AI Pet Instant Masterpiece (10651130298701, €9,95) */
  var DIGITAL_VARIANT = window.AIP_DIGITAL_VARIANT || 53852422668621;

  /* Bundle prezzo target: €34,95 (cover €27,95 + digital €9,95 = €37,90 → sconto €2,95).
     Lo sconto va applicato via Discount automatico Shopify (consigliato) oppure Functions. */
  var BUNDLE_TAG = 'cover_digital_bundle';

  /* ---------- Step navigation ---------- */
  function go(step) {
    $$('.aip-screen').forEach(function (el) {
      el.classList.toggle('is-active', String(el.dataset.screen) === String(step));
    });
    $$('.aip-step').forEach(function (el) {
      el.classList.toggle('is-active', Number(el.dataset.step) <= Number(step));
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ---------- Loader ---------- */
  function showLoader(text) {
    var l = $('#aip-loader');
    var t = $('#aip-loader-text');
    if (t && text) t.textContent = text;
    if (l) l.hidden = false;
  }
  function hideLoader() {
    var l = $('#aip-loader');
    if (l) l.hidden = true;
  }

  /* ---------- Step 1: upload ---------- */
  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () { resolve(fr.result); };
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });
  }
  /* Ridimensiona la foto nel browser prima dell'upload: le foto da smartphone (3-8MB, HEIC)
     sforerebbero i limiti POST del server → $_FILES vuoto ("no image uploaded"). Il canvas
     normalizza anche HEIC → JPEG. Ritorna un Blob (fallback al file originale in caso di errore). */
  function downscaleImage(file, maxDim, quality) {
    return new Promise(function (resolve) {
      try {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
          if (!w || !h) { URL.revokeObjectURL(url); return resolve(file); }
          var scale = Math.min(1, maxDim / Math.max(w, h));
          var nw = Math.round(w * scale), nh = Math.round(h * scale);
          var c = document.createElement('canvas');
          c.width = nw; c.height = nh;
          c.getContext('2d').drawImage(img, 0, 0, nw, nh);
          URL.revokeObjectURL(url);
          if (c.toBlob) {
            c.toBlob(function (blob) { resolve(blob || file); }, 'image/jpeg', quality || 0.88);
          } else {
            resolve(file);
          }
        };
        img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
        img.src = url;
      } catch (e) { resolve(file); }
    });
  }

  function handleFile(file) {
    if (!file || !file.type.startsWith('image/')) return alert(((window.AIP_I18N||{}).upload_image||"Please upload an image."));
    if (file.size > 25 * 1024 * 1024) return alert(((window.AIP_I18N||{}).too_large||"Image too large (max 25MB)."));
    state.petPhotoFile = file;
    state.petPhotoS3Url = null;
    showLoader(((window.AIP_I18N||{}).uploading||"Uploading your photo…"));
    // Preview locale immediata
    readFileAsDataUrl(file).then(function (url) {
      state.petPhotoDataUrl = url;
      var thumb = $('#aip-pet-thumb');
      if (thumb) thumb.src = url;
    });
    // Ridimensiona → upload S3 (URL pubblico richiesto dal proxy Gemini)
    downscaleImage(file, 1600, 0.88).then(function (blob) {
      var fd = new FormData();
      fd.append('image', blob, 'pet.jpg');
      fd.append('folder', 'ai-pet');
      return fetch(apiBase() + '/coverlab_studio_upload.php', { method: 'POST', body: fd });
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.success) throw new Error((data && data.message) || ((window.AIP_I18N||{}).upload_failed||"Upload failed"));
        state.petPhotoS3Url = data.s3_url;
        hideLoader();
        go(2);
      })
      .catch(function (err) {
        hideLoader();
        console.error('[AIP] Upload error:', err);
        alert(((window.AIP_I18N||{}).upload_error||"Photo upload error: ") + err.message + ((window.AIP_I18N||{}).upload_error_hint||"\n\nAI generation requires the upload to S3. Check the connection to the Coverlab backend."));
      });
  }

  function setupUploader() {
    var input = $('#aip-file-input');
    var dropzone = $('.aip-uploader');
    if (!input || !dropzone) return;
    input.addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0];
      if (f) handleFile(f);
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      dropzone.addEventListener(ev, function (e) {
        e.preventDefault(); e.stopPropagation();
        dropzone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      dropzone.addEventListener(ev, function (e) {
        e.preventDefault(); e.stopPropagation();
        dropzone.classList.remove('is-dragover');
      });
    });
    dropzone.addEventListener('drop', function (e) {
      var f = e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) handleFile(f);
    });
  }

  /* ---------- Step 2: style picker ---------- */
  function setupStyles() {
    $$('.aip-style').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.aip-style').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.selectedStyle = btn.dataset.style;
        var gen = $('#aip-generate');
        if (gen) gen.disabled = false;
      });
    });
    var changeBtn = $('#aip-change-photo');
    if (changeBtn) changeBtn.addEventListener('click', function () { go(1); });
    var gen = $('#aip-generate');
    if (gen) gen.addEventListener('click', generatePreviews);
  }

  /* ---------- Real AI generation via Gemini Nano Banana 2 ----------
     Endpoint: <coverlabApiBase>/coverlab_gemini_lifestyle_proxy.php
     Body JSON: { source_image_url, prompt, model, aspect_ratio, image_size, upload_s3 }
     Response: { success, image_url, model, fallback_used, ... }
  */

  /* Style → 4 prompt variants per generare 4 anteprime diverse */
  function buildPromptsForStyle(style) {
    var stylePrompts = {
      renaissance: 'Renaissance oil painting portrait of this pet, masterpiece quality, dramatic chiaroscuro lighting, classical art style, rich textured background',
      watercolor:  'Soft watercolor painting portrait of this pet, pastel color palette, delicate brushstrokes, minimal abstract background, hand-painted aesthetic, dreamy atmosphere',
      anime:       'Anime cartoon portrait of this pet, vibrant saturated colors, kawaii style, big sparkly expressive eyes, cel-shaded illustration, manga art style',
      plush:       '3D plush toy version of this pet, fluffy fur texture, soft studio lighting, neutral background, cute toy-like proportions, photorealistic 3D render',
      popart:      'Pop art portrait of this pet, Andy Warhol inspired style, bold flat colors, high contrast, screen-print aesthetic, graphic design poster look',
      lineart:     'Minimal continuous line art portrait of this pet, single elegant brush line drawing, plain white background, refined simplicity, modern editorial style'
    };
    var base = stylePrompts[style] || stylePrompts.renaissance;
    // Suffisso anti-cornice: dico esplicitamente NO frame/border/passepartout/canvas
    var noFrame = '. IMPORTANT: full-bleed image only, no picture frame, no border, no canvas edge, no passepartout, no matting, no wall behind. Pure portrait filling the entire image.';
    return [
      base + ', front-facing centered composition, square crop' + noFrame,
      base + ', three-quarter angle composition, slight head tilt' + noFrame,
      base + ', close-up portrait composition, detailed facial features' + noFrame,
      base + ', alternative pose interpretation, creative variation' + noFrame
    ];
  }

  function generateOneAI(sourceUrl, prompt) {
    return fetch(apiBase() + '/coverlab_gemini_lifestyle_proxy.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        source_image_url: sourceUrl,
        prompt: prompt,
        model: AI_MODEL,
        aspect_ratio: '1:1',
        image_size: AI_IMAGE_SIZE,
        upload_s3: '1'
      })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || !d || !d.success) throw new Error((d && d.message) || ('HTTP ' + r.status));
        return d;
      });
    });
  }

  function generatePreviews() {
    var style = state.selectedStyle || 'renaissance';
    if (!state.petPhotoS3Url) {
      alert(((window.AIP_I18N||{}).not_on_s3||"Photo not uploaded to S3 yet. Try again in a moment."));
      return;
    }
    showLoader(((window.AIP_I18N||{}).generating||"Generating your AI portraits…"));
    go(3);

    // Reset preview cards
    var grid = $('#aip-preview-grid');
    if (grid) {
      grid.innerHTML = '';
      for (var i = 0; i < 4; i++) {
        var card = document.createElement('div');
        card.className = 'aip-preview-card';
        card.dataset.i = i;
        var skel = document.createElement('div');
        skel.className = 'aip-preview-card__skel';
        card.appendChild(skel);
        grid.appendChild(card);
      }
    }
    var confirmBtn = $('#aip-confirm-preview');
    if (confirmBtn) confirmBtn.disabled = true;
    state.selectedPreviewIdx = null;
    state.previews = [];

    var prompts = buildPromptsForStyle(style);
    var doneCount = 0;
    var anySuccess = false;

    prompts.forEach(function (prompt, idx) {
      generateOneAI(state.petPhotoS3Url, prompt)
        .then(function (data) {
          state.previews[idx] = { url: data.image_url, style: style, prompt: prompt, model: data.model };
          var card = $$('.aip-preview-card')[idx];
          if (card) {
            card.innerHTML = '';
            var img = document.createElement('img');
            img.src = data.image_url;
            img.alt = 'AI preview ' + (idx + 1);
            img.loading = 'lazy';
            card.appendChild(img);
            card.addEventListener('click', function () { selectPreview(idx); });
          }
          anySuccess = true;
        })
        .catch(function (err) {
          console.error('[AIP] Generation ' + idx + ' failed:', err);
          var card = $$('.aip-preview-card')[idx];
          if (card) {
            card.innerHTML = '<div style="padding:14px;font-size:.8rem;color:#a14;text-align:center;">Errore: ' + (err.message || 'generation failed') + '</div>';
          }
        })
        .finally(function () {
          doneCount++;
          if (doneCount >= prompts.length) {
            hideLoader();
            if (!anySuccess) {
              alert('Nessuna anteprima generata. Verifica che il backend Coverlab sia raggiungibile.');
            }
          }
        });
    });
  }

  function selectPreview(idx) {
    state.selectedPreviewIdx = idx;
    $$('.aip-preview-card').forEach(function (card, i) {
      card.classList.toggle('is-selected', i === idx);
    });
    var confirmBtn = $('#aip-confirm-preview');
    if (confirmBtn) confirmBtn.disabled = false;
  }

  /* ---------- Step 4: product picker ---------- */
  function setupProductPicker() {
    var radios = $$('input[name="aip-product"]');
    radios.forEach(function (r) {
      r.addEventListener('change', function () { state.product = r.value; });
    });
    var cm = $('#aip-cover-model');
    if (cm) cm.addEventListener('change', function () { state.coverModel = cm.value; });
    var pf = $('#aip-poster-format');
    if (pf) pf.addEventListener('change', function () {
      state.posterFormat = pf.value;
      var pp = $('#aip-poster-price');
      if (pp && POSTER_PRICES[pf.value]) pp.textContent = POSTER_PRICES[pf.value];
    });
    var bm = $('#aip-bundle-model');
    if (bm) bm.addEventListener('change', function () { state.bundleModel = bm.value; });

    var confirmBtn = $('#aip-confirm-preview');
    if (confirmBtn) confirmBtn.addEventListener('click', function () {
      if (state.selectedPreviewIdx === null) return;
      state.finalDesignUrl = state.previews[state.selectedPreviewIdx].url;
      var img = $('#aip-final-img');
      if (img) img.src = state.finalDesignUrl;
      // Apply mock to product cards
      var phoneDesign = $('.aip-mockup__phone-design');
      var frameDesign = $('.aip-mockup__frame-design');
      if (phoneDesign) phoneDesign.style.backgroundImage = 'url("' + state.finalDesignUrl + '")';
      if (frameDesign) frameDesign.style.backgroundImage = 'url("' + state.finalDesignUrl + '")';
      go(4);
    });

    var cart = $('#aip-add-to-cart');
    if (cart) cart.addEventListener('click', addToCart);
  }

  /* ---------- Add to cart ---------- */
  function addToCart() {
    if (!state.finalDesignUrl) return;
    var btn = $('#aip-add-to-cart');
    if (btn) btn.disabled = true;
    showLoader('Aggiungo al carrello…');

    var baseProps = {
      '_AI_design_url': state.finalDesignUrl,
      '_AI_style': state.selectedStyle,
      'AI Pet Portrait': 'Yes'
    };
    var items = [];

    if (state.product === 'cover') {
      var vid = COVER_VARIANTS[state.coverModel];
      if (!vid) return failVariant(btn);
      items.push({ id: vid, quantity: 1, properties: extend(baseProps, { 'Phone Model': humanModel(state.coverModel) }) });
    } else if (state.product === 'poster') {
      var pid = POSTER_VARIANTS[state.posterFormat];
      if (!pid) return failVariant(btn);
      items.push({ id: pid, quantity: 1, properties: extend(baseProps, { 'Formato': state.posterFormat }) });
    } else if (state.product === 'digital') {
      items.push({ id: DIGITAL_VARIANT, quantity: 1, properties: extend(baseProps, { 'Tipo': 'Download digitale' }) });
    } else if (state.product === 'bundle') {
      var bvid = COVER_VARIANTS[state.bundleModel];
      if (!bvid) return failVariant(btn);
      // Tag bundle nei properties → permette al Discount automatico Shopify di matchare
      var bundleProps = extend(baseProps, { '_bundle': BUNDLE_TAG });
      items.push({ id: bvid,            quantity: 1, properties: extend(bundleProps, { 'Phone Model': humanModel(state.bundleModel), 'Bundle': 'Cover + Digital' }) });
      items.push({ id: DIGITAL_VARIANT, quantity: 1, properties: extend(bundleProps, { 'Tipo': 'Download digitale', 'Bundle': 'Cover + Digital' }) });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(function () { window.location.href = '/cart'; })
    .catch(function (e) {
      hideLoader();
      if (btn) btn.disabled = false;
      alert(((window.AIP_I18N||{}).cart_error||"Error adding to cart. Please try again."));
      console.error(e);
    });
  }
  function failVariant(btn) {
    hideLoader();
    if (btn) btn.disabled = false;
    alert(((window.AIP_I18N||{}).variant_missing||"Variant not found for this choice."));
  }
  function extend(a, b) {
    var out = {};
    for (var k in a) if (Object.prototype.hasOwnProperty.call(a, k)) out[k] = a[k];
    for (var k2 in b) if (Object.prototype.hasOwnProperty.call(b, k2)) out[k2] = b[k2];
    return out;
  }

  function humanModel(slug) {
    return slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  /* ---------- Back/forward step buttons ---------- */
  function setupGoButtons() {
    $$('[data-go]').forEach(function (b) {
      b.addEventListener('click', function () { go(Number(b.dataset.go)); });
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    setupUploader();
    setupStyles();
    setupProductPicker();
    setupGoButtons();
  });
})();
